
export default defineNuxtPlugin(() => {
  const api = $fetch.create({
    baseURL: useRuntimeConfig().public.baseUrl,

    onRequest(context) {
      const { options } = context
      const optionsHeaders = new Headers(options.headers)
      options.headers = optionsHeaders || {}

      const authToken = useCookie('token').value

      if (authToken) {
        options.headers.set('authorization', `Token ${authToken}`)
      } else {
        options.headers.set('authorization', 'null')
      }
    },

    onResponseError({ response, request }) {
      const { $store } = useNuxtApp()

      if (response.status === 401 && !request.includes('/api-token-auth/')) {
        $store.dispatch('login/logout', { root: true })
        navigateTo('/login')
      }

      if (response.status === 500) {
        navigateTo('/error')
      }
    }
  })
  return {
    provide: {
      api
    }
  }
})
